exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".auth[data-v-5c3a1757]{background-color:#000;color:#fff}", ""]);

// exports
